<template>
    <tbody>
        <template v-for="(row, rowIndex) in rows">
            <tr :style="{ borderWidth: retrieveBorderWidth(row), fontWeight: retrieveFontWeight(row) }" :hidden="retrieveHidden(rowIndex)">
                <template v-for="(cell, cellIndex) in row.cells">
                    <template v-if="cell.type">
                        <td v-if="cell.type === 'accordion' && cell.accordion && row.table"
                            :style="{ borderColor: retrieveBorderColour(cell), borderWidth: retrieveBorderWidth(cell), backgroundColor: retrieveBackgroundColour(cell), color: retrieveColour(cell), textAlign: retrieveAlignment(cell) }"
                            :class="retrieveClasses(cell)"
                        >
                            <button :title="retrieveTooltip(cell.accordion, true, ! retrieveExpanded(row.table))" :aria-controls="retrieveTableId(rowIndex)" :aria-expanded="retrieveExpanded(row.table).toString()" @click.stop="toggleAccordion($event, cell.accordion)">
                                <i v-if="retrieveExpanded(row.table)" class="fal fa-minus-circle"></i>
                                <i v-else class="fal fa-plus-circle"></i>
                            </button>
                        </td>

                        <td v-else-if="cell.type === 'option'"
                            :style="{ borderColor: retrieveBorderColour(cell), borderWidth: retrieveBorderWidth(cell), backgroundColor: retrieveBackgroundColour(cell), color: retrieveColour(cell), textAlign: retrieveAlignment(cell) }"
                            :class="retrieveClasses(cell)"
                        >
                            <div class="form-group form-group-toggle">
                                <div class="radio-group">
                                    <input
                                        :id="cell.value"
                                        type="radio"
                                        class="form-control toggle"
                                        :name="currentQuestionId"
                                        :value="cell.value"
                                        required
                                        :autofocus="rowIndex === 0"
                                        @change.stop="updateCurrentAnswer($event, rowIndex)"
                                    >

                                    <label :for="cell.value" class="form-label-radio"></label>
                                </div>
                            </div>
                        </td>

                        <td v-else
                            :style="{ width: retrieveCellWidth(cell), borderColor: retrieveBorderColour(cell), borderWidth: retrieveBorderWidth(cell), backgroundColor: retrieveBackgroundColour(cell), color: retrieveColour(cell), textAlign: retrieveAlignment(cell) }"
                            :class="retrieveClasses(cell, retrieveClasses(columns.headings[cellIndex]))"
                            v-html="formatCell(cell)">
                        </td>
                    </template>

                    <template v-else>
                        <td :style="{ width: retrieveCellWidth(cell), borderColor: retrieveBorderColour(cell), borderWidth: retrieveBorderWidth(cell), backgroundColor: retrieveBackgroundColour(cell), color: retrieveColour(cell), textAlign: retrieveAlignment(cell) }"
                            :class="retrieveClasses(cell, retrieveClasses(columns.headings[cellIndex]))">
                            <template v-if="cell.api">
                                <template v-if="cell.api.toggle">
                                    <div class="form-group form-group-toggle">

                                        <input
                                            :id="cell.api.id"
                                            :name="cell.api.id"
                                            type="checkbox"
                                            class="form-control toggle"
                                            value="on"
                                            v-model="cell.api.toggle.value"
                                            @change.stop="callApi(cell.api)"
                                        >

                                        <label :for="cell.api.id" class="form-label-checkbox"></label>
                                    </div>
                                </template>

                                <template v-else>
                                    <button type="button" class="button" :title="retrieveTooltip(cell.api.icon)" @click.stop="callApi(cell.api)">
                                        <i :class="retrieveIconClass(cell.api)"></i>
                                    </button>
                                </template>
                            </template>

                            <template v-else-if="cell.select">
                                <button type="button" class="button" @click.stop="selectInvestor(cell.select)" :title="retrieveTooltip(cell.select.icon)">
                                    <i :class="retrieveIconClass(cell.select)"></i>
                                </button>
                            </template>

                            <template v-else-if="cell.text">
                                <text-extended
                                    :title="retrieveTitle(cell.text.data)"
                                    :sections="retrieveSections(cell.text.data)"
                                    :fontSize="retrieveFontSize(cell.text.data)"
                                    :level="3"
                                    :heading="3"
                                />
                            </template>

                            <template v-else>
                                <span v-html="formatCell(cell)"></span>
                            </template>

                        </td>

                    </template>

                </template>
            </tr>

            <template v-if="row.table">
                <tr class="stripe-correction"></tr>

                <tr v-show="retrieveExpanded(row.table)" :id="retrieveTableId(rowIndex)">
                    <td :colspan="colspan">
                        <data-table
                            :domain="domain"
                            :title="retrieveTitle(row.table.data)"
                            :classes="retrieveClasses(row.table.data)"
                            :columns="row.table.data.columns"
                            :colspan="row.table.data.columns.headings.length"
                            :rows="row.table.data.rows"
                            :limit="row.table.data.limit_rows"
                            :tables="row.table.data.tables"
                            :footer="row.table.data.footer"
                            :level="retrieveNextLevel(level)"
                            :heading="heading"
                        />
                    </td>
                </tr>

            </template>

            <tr v-if="row.warning" v-show="currentRow === rowIndex" :id="'option-warning-' + rowIndex" class="warning">
                <td :colspan="colspan">
                    <div  class="alert alert-warning">
                        {{ row.warning }}
                    </div>
                </td>
            </tr>

        </template>

        <tr v-for="table in tables">
            <td :colspan="colspan">
                <data-table
                    :domain="domain"
                    :title="retrieveTitle(table.data)"
                    :classes="retrieveClasses(table.data)"
                    :columns="table.data.columns"
                    :colspan="table.data.columns.headings.length"
                    :rows="table.data.rows"
                    :limit="table.data.limit_rows"
                    :tables="table.data.tables"
                    :footer="table.data.footer"
                    :level="retrieveNextLevel(level)"
                    :heading="heading"
                />
            </td>
        </tr>

        <tr v-if="limit && rows.length > limit" class="showMore">
            <td :colspan="colspan">
                <button v-on:click="showMore($event)" class="button button-primary">
                    Show More
                </button>
            </td>
        </tr>

        <data-table-footer v-if="footer" :colspan="colspan" :footer="footer"/>
    </tbody>
</template>

<script>

    import Widget from './Widget';

    export default Widget.extend({
        props: [
            'domain',
            'colspan',
            'columns',
            'rows',
            'limit',
            'tables',
            'footer',
            'level',
            'heading',
            'currentQuestionId',
            'currentAnswer'
        ],

        data() {
            return {
                currentRow: null
            }
        },

        methods: {
            toggleAccordion(event, accordionData) {
                const thisAccordionButton = event.currentTarget;

                if (thisAccordionButton.getAttribute('aria-expanded') !== 'false') {
                    this.collapseAccordion(thisAccordionButton, accordionData);
                } else {
                    this.expandAccordion(thisAccordionButton, accordionData);
                }
            },

            expandAccordion(accordionButton, accordionData) {
                const expanded = true;
                document.getElementById(accordionButton.getAttribute('aria-controls')).style.display = 'table-row';
                accordionButton.setAttribute('aria-expanded', expanded);
                accordionButton.setAttribute('title', this.retrieveTooltip(accordionData, true, ! expanded));
                accordionButton.firstChild.classList.remove('fa-plus-circle');
                accordionButton.firstChild.classList.add('fa-minus-circle');
            },

            collapseAccordion(accordionButton, accordionData) {
                const expanded = false;
                document.getElementById(accordionButton.getAttribute('aria-controls')).style.display = 'none';
                accordionButton.setAttribute('aria-expanded', expanded);
                accordionButton.setAttribute('title', this.retrieveTooltip(accordionData, true, ! expanded));
                accordionButton.firstChild.classList.add('fa-plus-circle');
                accordionButton.firstChild.classList.remove('fa-minus-circle');
            },

            retrieveExpanded(table) {
                return this.retrieveDisplay(table.data) !== 'collapsed';
            },

            retrieveTableId(rowIndex) {
                return 'table-' + this._uid + '-row-' + rowIndex;
            },

            retrieveHidden(count) {
                return this.limit && count >= this.limit ? 'hidden' : null;
            },

            retrieveCellWidth(cell) {
                if (((this.formatCell(cell).toString().length > 0) || cell.text) && (! cell.media) && this.colspan <= 2) {
                    return '100%';
                }

                return null;
            },

            showMore(event) {
                const thisRow = event.target.parentElement.parentElement;

                [].forEach.call(thisRow.parentElement.children, row => {
                    row.removeAttribute('hidden');
                });

                thisRow.remove();
            },

            selectInvestor(object) {
                this.blockAll();

                axios.post('/actions/selectInvestor', {
                    'investorId': object.id,
                    'investorCode': object.investor_code,
                    'investorName': object.investor_name,
                }).then(response => {
                    const data = response.data;

                    if (object.redirect) {
                        return this.redirect(object);
                    }

                    flash(object.display, 'success', 10, true);

                    window.events.$emit('updateInvestor', object.id);
                    window.events.$emit('updateInvestorName', object.investor_name);

                    if (data.refresh_table) {
                        this.refreshAll();
                    } else {
                        this.unblockAll();
                    }

                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                });
            },

            redirect(object) {
                if (! object || ! object.redirect) {
                    return;
                }

                flash('Redirecting...', 'success', 300);

                window.location = object.redirect.url;
            },

            updateCurrentAnswer(event, rowIndex) {
                event.preventDefault();
                this.currentRow = rowIndex;
                window.events.$emit('updateCurrentAnswer', event.target.value);
            }
        },
    });

</script>
